import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSnowflake, faTimes } from '@fortawesome/free-solid-svg-icons';

const ThawReminderAlert = ({ reminders, onDismiss, onDismissAll }) => {
  if (!reminders || reminders.length === 0) {
    return null;
  }

  // Group reminders by urgency (only today and overdue)
  const overdueReminders = reminders.filter(r => r.is_thaw_overdue);
  const todayReminders = reminders.filter(r => r.is_thaw_today && !r.is_thaw_overdue);

  const renderReminderItem = (reminder, variant) => (
    <div
      key={`${reminder.ingredient_id}-${reminder.ingredient_type}-${reminder.day_of_week}`}
      className="thaw-reminder-item d-flex justify-content-between align-items-center py-1"
    >
      <div className="thaw-reminder-details">
        <strong>{reminder.ingredient_name}</strong>
        <span className="text-muted mx-2">for</span>
        <em>{reminder.recipe_title}</em>
        <span className="text-muted mx-2">({reminder.day_of_week})</span>
        {reminder.thaw_days_ahead > 0 && (
          <span className="badge bg-secondary ms-2">
            {reminder.thaw_days_ahead}d advance
          </span>
        )}
      </div>
      <Button
        variant={`outline-${variant}`}
        size="sm"
        onClick={() => onDismiss(reminder)}
        className="thaw-dismiss-btn ms-2"
        title="Dismiss this reminder"
      >
        <FontAwesomeIcon icon={faTimes} />
      </Button>
    </div>
  );

  const renderSection = (title, items, variant) => {
    if (items.length === 0) return null;

    return (
      <Alert variant={variant} className={`thaw-reminder-alert thaw-reminder-${variant} mb-2`}>
        <div className="d-flex align-items-center mb-2">
          <FontAwesomeIcon icon={faSnowflake} className="me-2" />
          <strong>{title}</strong>
          {items.length > 1 && (
            <span className="badge bg-light text-dark ms-2">{items.length}</span>
          )}
        </div>
        <div className="thaw-reminder-list">
          {items.map(reminder => renderReminderItem(reminder, variant))}
        </div>
      </Alert>
    );
  };

  return (
    <div className="thaw-reminder-container mb-3">
      {overdueReminders.length > 0 && renderSection(
        'Overdue - Should have thawed already!',
        overdueReminders,
        'danger'
      )}
      {todayReminders.length > 0 && renderSection(
        'Thaw Today',
        todayReminders,
        'warning'
      )}


      {reminders.length > 1 && (
        <div className="text-end">
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={onDismissAll}
            className="thaw-dismiss-all-btn"
          >
            Dismiss All Thaw Reminders
          </Button>
        </div>
      )}
    </div>
  );
};

export default ThawReminderAlert;
